var map = {
	"./": [
		57649
	],
	"./dark": [
		21938,
		938
	],
	"./dark/": [
		21938,
		938
	],
	"./dark/index": [
		21938,
		938
	],
	"./dark/index.ts": [
		21938,
		938
	],
	"./dark/palette": [
		33809,
		809
	],
	"./dark/palette.ts": [
		33809,
		809
	],
	"./dark/typography": [
		67949,
		949
	],
	"./dark/typography.ts": [
		67949,
		949
	],
	"./index": [
		57649
	],
	"./index.ts": [
		57649
	],
	"./light": [
		2482,
		482
	],
	"./light/": [
		2482,
		482
	],
	"./light/index": [
		2482,
		482
	],
	"./light/index.ts": [
		2482,
		482
	],
	"./light/palette": [
		83089,
		470
	],
	"./light/palette.ts": [
		83089,
		470
	],
	"./light/typography": [
		43661,
		661
	],
	"./light/typography.ts": [
		43661,
		661
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 28153;
module.exports = webpackAsyncContext;